import { Checkbox, Form, Input, App, Spin } from "antd";
import { observer } from "mobx-react";
import { useState } from "react";
import { useCallback } from "react";
import { RealCommerceError } from "../../../../exceptions";
import { useRealCommerceErrorHandling } from "../../../../hooks";
import { _i, __ } from "../../../../utils";
import { useStores } from "../../../../store";
const AccountAddFromEnvatoForm = observer(_ref => {
  let {
    onSave
  } = _ref;
  const {
    message
  } = App.useApp();
  const {
    accountStore
  } = useStores();
  const {
    session
  } = accountStore;
  const [busy, setBusy] = useState(false);
  const initialValues = {
    purchaseCode: "",
    terms: false,
    privacy: false
  };
  const [form] = Form.useForm();
  const handleRealCommerceError = useRealCommerceErrorHandling();
  const onFinish = useCallback(async values => {
    setBusy(true);
    try {
      const {
        envatoPurchase: {
          product: {
            name
          }
        }
      } = await accountStore.createAccountEnvato(values);
      message.success(_i(__("You have successfully added your {{strong}}%s{{/strong}} license to your devowl.io account.", name), {
        strong: /*#__PURE__*/React.createElement("strong", null)
      }));
      session.fetchSubscriptionsAndLicenses();
      form.resetFields();
      onSave === null || onSave === void 0 ? void 0 : onSave();
    } catch (e) {
      if (e instanceof RealCommerceError) {
        handleRealCommerceError(e);
      }
    } finally {
      setBusy(false);
    }
  }, []);
  return /*#__PURE__*/React.createElement(Spin, {
    spinning: busy
  }, /*#__PURE__*/React.createElement(Form, {
    form: form,
    onFinish: onFinish,
    name: "add-from-envato",
    layout: "vertical",
    initialValues: initialValues,
    labelWrap: true
  }, /*#__PURE__*/React.createElement(Form.Item, {
    name: "purchaseCode",
    label: __("Purchase code (license key)"),
    required: true,
    rules: [{
      required: true,
      message: __("Please enter your purchase code!")
    }]
  }, /*#__PURE__*/React.createElement(Input, null)), /*#__PURE__*/React.createElement(Form.Item, {
    name: "terms",
    valuePropName: "checked",
    rules: [{
      type: "boolean",
      required: true,
      transform: value => value || undefined,
      message: __("Please confirm that you have read the Terms and Conditions!")
    }]
  }, /*#__PURE__*/React.createElement(Checkbox, null, _i(__("I have read and agree to the {{a}}Terms and Conditions{{/a}}."), {
    a: /*#__PURE__*/React.createElement("a", {
      href: __("https://devowl.io/terms/"),
      target: "_blank",
      rel: "noreferrer"
    })
  }))), /*#__PURE__*/React.createElement(Form.Item, {
    name: "privacy",
    valuePropName: "checked",
    rules: [{
      type: "boolean",
      required: true,
      transform: value => value || undefined,
      message: __("Please confirm that you have read the privacy policy!")
    }]
  }, /*#__PURE__*/React.createElement(Checkbox, null, _i(__("I have read the {{a}}Privacy Policy{{/a}}"), {
    a: /*#__PURE__*/React.createElement("a", {
      href: __("https://devowl.io/privacy-policy/"),
      target: "_blank",
      rel: "noreferrer"
    })
  })))));
});
export { AccountAddFromEnvatoForm };